import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportExternalAccountsReadyGridLayoutService } from '@irb/irb-clients/import-external-accounts-ready-dialog/import-external-accounts-ready.grid-layout.service';
import { IExternalAccountsImportResponse } from '@irb/irb-clients/irb-clients.model';

@Component({ standalone: false,
  selector: 'irb-import-external-accounts-ready-dialog',
  templateUrl: './import-external-accounts-ready-dialog.component.html',
  styleUrls: ['./import-external-accounts-ready-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportExternalAccountsReadyDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  inboundAccounts: Array<number>;
  results: Array<any> = [];
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportExternalAccountsReadyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IExternalAccountsImportResponse,
    public as: AppService,
    private gls: ImportExternalAccountsReadyGridLayoutService
  ) {

    this.inboundAccounts = [].concat(this.data.responseData.newExtAccts).concat(this.data.responseData.overrideExtAccts);
    
    this.data.responseData.restoreAcctList?.forEach((r:any) => {
        this.inboundAccounts.push(r.accountNumber);
    });
    
    this.inboundAccounts.forEach((r: any) => {
      this.results.push({
        accountNumber: r,
        status: (this.data.responseData.overrideExtAccts.indexOf(r) === -1) ? "New external account" : "Existing external account",
        result: (this.data.responseData.overrideExtAccts.indexOf(r) === -1) ? "Will be added" : "Will be OVERWRITTEN"
      });
    });

    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbClientsEvents.IMPORT_EXTERNAL_ACCOUNTS_COMPLETE, this.data.responseData);
    this.close();
  }
}
